import { type FC } from 'react';

import { SalesforceLeadContactStep } from '@eneco/flows/components';
import { usePlaceholderContent } from '@sitecore/common';
import { HeatPumpLeadFlowContactDetailsStepRendering } from '@sitecore/types/HeatPumpLeadFlowContactDetailsStep';
import { useMachine } from '@xstate/react';

import { useFlowTracking } from '../hooks/useFlowTracking';
import { leadsMachine } from '../machines/leadsMachine';

export const ContactDetailsStep: FC = () => {
  const [leadsState, sendToLeadsMachine] = useMachine(leadsMachine);
  const { trackPurchase } = useFlowTracking();
  const { HeatPumpLeadFlowContactDetailsStep: { fields: textualData } = {} } = usePlaceholderContent<{
    HeatPumpLeadFlowContactDetailsStep: HeatPumpLeadFlowContactDetailsStepRendering;
  }>();

  return (
    <SalesforceLeadContactStep
      textualData={textualData}
      leadsState={leadsState}
      sendToLeadsMachine={sendToLeadsMachine}
      trackPurchase={trackPurchase}
      successDependencies="leadsStateAndActions"
      extraLeadData={{ Interest_Heatpump__c: 'true' }}
    />
  );
};
